import { combineReducers } from 'redux';
import { default as list } from 'notifications_config/reducers/notifications_config_list_reducers';
import { default as form } from 'notifications_config/reducers/notifications_config_form_reducers';

export const notification_configReducers = combineReducers({ list, form });



// WEBPACK FOOTER //
// src/modules/secured/modules/notifications_config/reducers/index.js